/**
 * The attribute that marks the restore banner: {@link onUserInput} ignores
 * input inside it.
 */
export const RESTORE_BANNER_ATTRIBUTE = "data-feedback-restore-banner";

/**
 * Calls `listener` on the user's own input on the page: a trusted
 * `pointerdown` or `keydown` outside the restore banner. Returns the
 * function that removes the listeners.
 */
export function onUserInput(listener: () => void): () => void {
  function onInput(event: Event) {
    // `=== false`: test DOMs leave `isTrusted` undefined.
    if (event.isTrusted === false) return;
    const { target } = event;
    if (
      target instanceof Element &&
      target.closest(`[${RESTORE_BANNER_ATTRIBUTE}]`)
    ) {
      return;
    }
    listener();
  }
  document.addEventListener("pointerdown", onInput, true);
  document.addEventListener("keydown", onInput, true);
  return () => {
    document.removeEventListener("pointerdown", onInput, true);
    document.removeEventListener("keydown", onInput, true);
  };
}
